// Per-user cache of the home page's noticeboard and (for coaches) "Today"
// data, so a return visit renders them immediately instead of
// popping them in and pushing the tiles down. The page always refreshes in the
// background and overwrites this.
//
// Today's sessions are only valid for the day they were saved. Noticeboard
// posts are kept until replaced, since the page always reloads them. Cleared on
// logout because it holds gymnasts' names.

const PREFIX = 'tl-dashboard:';

const pad = (n) => String(n).padStart(2, '0');
const dayKey = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

function load(userId) {
  try {
    return JSON.parse(localStorage.getItem(PREFIX + userId)) || null;
  } catch {
    return null;
  }
}

// Returns whichever of { todaySessions, noticeboard, competitions, codeOfDay }
// are still valid. Competitions, like the noticeboard, are kept
// until replaced; the code of the day until it expires.
export function readDashboardCache(userId, now = new Date()) {
  const stored = userId ? load(userId) : null;
  if (!stored) return {};
  const out = {};
  if (stored.day === dayKey(now) && stored.todaySessions) out.todaySessions = stored.todaySessions;
  if (stored.noticeboard) out.noticeboard = stored.noticeboard;
  if (stored.competitions) out.competitions = stored.competitions;
  if (stored.codeOfDay && new Date(stored.codeOfDay.expiresAt) > now) out.codeOfDay = stored.codeOfDay;
  return out;
}

// Merges `data` into the cache, keeping other still-valid fields.
export function writeDashboardCache(userId, data, now = new Date()) {
  if (!userId) return;
  const next = { ...readDashboardCache(userId, now), ...data, day: dayKey(now) };
  try {
    localStorage.setItem(PREFIX + userId, JSON.stringify(next));
  } catch {
    // Storage full or unavailable (e.g. private browsing): just skip caching.
  }
}

export function clearDashboardCache() {
  try {
    Object.keys(localStorage)
      .filter(k => k.startsWith(PREFIX))
      .forEach(k => localStorage.removeItem(k));
  } catch {
    // Nothing to clear if storage is unavailable.
  }
}
